import { TableCell, DateCell } from 'ui/tableCell';
import type { InboundSMSTableColumnData, InboundSMS } from './types';

export const configureTableColumns = (isUuidBased: boolean): InboundSMSTableColumnData[] => {
  return [
    {
      name: isUuidBased ? 'UserIdentifier' : 'Email',
      align: 'flex-start',
      sortable: false,
      value: isUuidBased ? 'userIdentifier' : 'email',
      RowCell: ({ row }) => <TableCell>{isUuidBased ? row.userIdentifier : row.email}</TableCell>,
    },
    {
      name: 'Created',
      align: 'flex-start',
      value: 'createdAt',
      RowCell: ({ row }) => <DateCell timestamp={row.createdAt} />,
    },
    {
      name: 'Message',
      align: 'flex-start',
      sortable: false,
      value: 'smsMessage',
      RowCell: ({ row }) => <TableCell>{row.smsMessage}</TableCell>,
    },
    {
      name: 'From Phone Number',
      align: 'flex-start',
      sortable: false,
      value: 'fromPhoneNumber',
      RowCell: ({ row }) => <TableCell>{row.fromPhoneNumber}</TableCell>,
    },
    {
      name: 'To Phone Number',
      align: 'flex-start',
      sortable: false,
      value: 'toPhoneNumber',
      RowCell: ({ row }) => <TableCell>{row.toPhoneNumber}</TableCell>,
    },
  ];
};

export const inboundSmsFilterFn = (inboundSms: InboundSMS, filter: string) => {
  // sms either include an email or userIdentifier depending on the project type's configuration
  const userId = inboundSms.email || inboundSms.userIdentifier;

  if (userId?.includes(filter)) {
    return true;
  }

  if (inboundSms.smsMessage?.toLowerCase().includes(filter.toLowerCase())) {
    return true;
  }

  if (inboundSms.fromPhoneNumber?.includes(filter)) {
    return true;
  }

  if (inboundSms.toPhoneNumber?.includes(filter)) {
    return true;
  }

  return false;
};
